// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__3u_v1","mediaWrap":"styles_mediaWrap__oWnH0","title":"styles_title__nO_1y","contentWrap":"styles_contentWrap__uL73R","redirectLink":"styles_redirectLink__D9C0F"};
module.exports.__checksum = "7ec6522a4d99"
